// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { PowerBIReportModel } from "@store/Framework/Types/ApiModels";

const powerBIReportUrl = "api/v1/custom/powerbi/report";

interface GetPowerBIReportParameters extends ApiParameter {
    reportId: string;
    workspaceId: string;
    effectiveIdentityUserName?: string;
    effectiveIdentityRoles?: string;
}

export const getPowerBIReport = async (parameter: GetPowerBIReportParameters) => {
    const powerBIReport = await get<PowerBIReportModel>(`${powerBIReportUrl}`, parameter);
    return powerBIReport;
};
